import { Modal, Col } from "reactstrap";
import React, { useState } from "react";
import axios from "axios";

const NewHeadsetModal = ({ onHeadsetCreated }) => {
  const [modal, setModal] = useState(false);
  const [availablePids, setAvailablePids] = useState([]);


  const [form, setForm] = useState({
    headset_PID: "",
    headset_NAME: "",
    headset_MODEL: ""
  });

  const toggle = async () => {
    if (!modal) {
      try {
        const res = await axios.get(
          "/api/headset/headsets_enrollement",
          { withCredentials: true }
        );
        setAvailablePids(res || []);
      } catch (err) {
        console.error("Erreur chargement PID", err);
      }
    }
    setModal(!modal);
  };


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      await axios.post(
        "/api/headset/create",
        form,
        { withCredentials: true }
      );

      toggle();
      setForm({
        headset_PID: "",
        headset_NAME: "",
        headset_MODEL: ""
      });

      onHeadsetCreated?.();
    } catch (err) {
      console.error(err.response?.data || err);
      alert("⚠️Erreur lors de la création du casque\n➡️ PID manquant : Connectez-vous à partir du nouveau casque");
    }
  };

  return (
    <>
      <button className="btn btn-outline-primary" onClick={toggle}>
        +<i className="bx bxs-mask fs-3 py-0 align-middle"></i> Nouveau casque
      </button>

      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-header">
          <h5 className="modal-title">Nouveau casque XR</h5>
          <button className="close" onClick={toggle}>×</button>
        </div>

        <div className="modal-body">
          <Col md={12} className="mb-3">
            <input
              className="form-control"
              name="headset_NAME"
              placeholder="Nom du casque"
              value={form.headset_NAME}
              onChange={handleChange}
            />
          </Col>

          <Col md={12} className="mb-3">
            <select
              className="form-control"
              name="headset_PID"
              value={form.headset_PID}
              onChange={handleChange}
            >
              <option value="">Sélectionner un PID</option>
              {availablePids.map((h, idx) => (
                <option key={idx} value={h.headset_PID}>
                  {h.headset_PID}
                </option>
              ))}
            </select>
          </Col>


          <Col md={12} className="mb-3">
            <input
              className="form-control"
              name="headset_MODEL"
              placeholder="Modèle"
              value={form.headset_MODEL}
              onChange={handleChange}
            />
          </Col>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={toggle}>
            Annuler
          </button>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Créer
          </button>
        </div>
      </Modal>
    </>
  );
};

export default NewHeadsetModal;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license